export const ADDRESS_TEXTS = {
    MAIN_TITLE: "¡Wuuuuuujuuu!",
    BUTTON_LABELS: {
        EXPRESS: "Compras menores a 200 USD Express",
        MINOR: "Compras menores a 200 USD",
        MAJOR: "Compras mayores a 200 USD",
        APPLE: "Dirección residencial"
    },
    DOUBTS_TEXT: "─── ¿Tienes dudas?,",
    CONTACT_US_TEXT: "Contáctanos"
};